// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { S } from './styles';

import { parseDuration } from '../../../lib/utility';
import { PlayBackRateOptionType } from '../Player';
import Dropup from './Dropup/Dropup';
import { Subtitles, VideoUrlType } from '../../../types/Model';

interface PlayerControlProps extends Omit<ComponentPropsWithRef<'div'>, 'onVolumeChange'> {
  playing: boolean;
  isAutoNext: boolean;
  playedSeconds: number;
  lastDuration?: number;
  totalDuration: number;
  urls?: VideoUrlType[];
  resolution: string;
  playbackRate: PlayBackRateOptionType;
  playbackRateOptions: readonly PlayBackRateOptionType[];
  volume: number;
  muted: boolean;
  subtitles: Subtitles;
  onPlayPause: () => void;
  onSeek: (seconds: number) => void;
  onResolutionChange: (resolution: string) => void;
  onPlaybackRate: (rate: PlayBackRateOptionType) => void;
  onMutedChange: (mute: boolean) => void;
  onVolumeChange: (volume: number) => void;
  onTogglePip: () => void;
  onToggleFullScreen: () => void;
  onAutoNextResponse: (isAccepted: boolean) => void;
}

const PlayerControl: React.FC<PlayerControlProps> = (props => {
  const {
    playing,
    isAutoNext,
    playedSeconds,
    lastDuration,
    totalDuration,
    urls,
    resolution,
    playbackRate,
    playbackRateOptions,
    volume,
    muted,
    subtitles,
    onPlayPause,
    onSeek,
    onResolutionChange,
    onPlaybackRate,
    onMutedChange,
    onVolumeChange,
    onTogglePip,
    onToggleFullScreen,
    onAutoNextResponse,
    ...otherProps
  } = props;

  const [subtitle, setSubtitle] = useState<string>();

  const handleChangingQuality = () => {
    return (
      <S.LoadingAnimation />
    )
  };
  const handlePlay = () => {
    if (isAutoNext) {
      return (
        <S.AutoplayAnimation onClick={() => onAutoNextResponse(true)} />
      )
    } else {
      return (
        <S.PauseIcon />
      )
    }
  };
  const handlePause = () => {
    return (
      <S.PlayIcon />
    )
  };

  return (
    <S.Wrapper {...otherProps}>
      <S.MiddleControls onClick={isAutoNext ? undefined : onPlayPause}>
        {lastDuration === undefined ? playing ? handlePause() : handlePlay() : handleChangingQuality()}
        {isAutoNext && <S.AutoplayCancelText onClick={() => onAutoNextResponse(false)}><FormattedMessage id="F005" /></S.AutoplayCancelText>}
        <S.SubtitleText style={{ visibility: 'visible' }}>{subtitle}</S.SubtitleText>
      </S.MiddleControls>
      <S.BottomWrapper >
        <S.ControlWrapper>
          <S.LeftWrapper>
            <S.Time> {parseDuration(Math.ceil(playedSeconds)).all}/{parseDuration(Math.ceil(totalDuration)).all}</S.Time>
            <S.MiniIcon playing={playing} onClick={onPlayPause}/>
            <S.Rewind onClick={() => onSeek(playedSeconds - 5)} />
            <S.FastForward onClick={() => onSeek(playedSeconds + 5)} />
          </S.LeftWrapper>
          <S.RightWrapper>
            <S.Resolution
              urls={urls}
              resolution={resolution}
              onResolutionChange={onResolutionChange}
            />
            <Dropup
              options={playbackRateOptions}
              unit={'x'}
              handleChange={onPlaybackRate}
              initialSelected={playbackRate}
            />
            <S.VolumeBar
              volume={volume}
              muted={muted}
              onVolumeChange={onVolumeChange}
              onMutedChange={onMutedChange}
            />
            <S.Subtitle
              subtitles={subtitles}
              playedSeconds={playedSeconds}
              onSubtitleChange={setSubtitle}
            />
            <S.Pip onClick={onTogglePip} />
            <S.FullScreen onClick={onToggleFullScreen} />
          </S.RightWrapper>
        </S.ControlWrapper>
        <S.SeekWrapper>
          <S.SeekBar
            playedSeconds={playedSeconds}
            totalDuration={totalDuration}
            onSeek={onSeek}
          />
        </S.SeekWrapper>
      </S.BottomWrapper>
    </S.Wrapper>
  )
})

export { PlayerControl as default };
